// Brand-wide constants for The Golden Legends
export const BRAND = {
  name: "The Golden Legends",
  short: "TGL",
  twitchChannel: "m2gaming2",
  discordUrl: "https://discord.gg/BQprPjfSx",
  contactEmail: "ethan.poplin@gmail.com",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_core-game/artifacts/3ksuqcne_ChatGPT%20Image%20Apr%2028%2C%202026%2C%2009_24_50%20PM.png",
  heroBg:
    "https://images.unsplash.com/photo-1761437855598-011cf89b2ad4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxibGFjayUyMGFuZCUyMGdvbGQlMjBhYnN0cmFjdCUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzc3NDI2NjE2fDA&ixlib=rb-4.1.0&q=85",
  games: {
    rocketLeague: "https://images.pexels.com/photos/4758149/pexels-photo-4758149.jpeg",
    fortnite: "https://images.unsplash.com/photo-1542751371-adc38448a05e",
    minecraft: "https://images.pexels.com/photos/22776052/pexels-photo-22776052.jpeg",
  },
  tournamentArena: "https://images.pexels.com/photos/7915245/pexels-photo-7915245.jpeg",
  players: [
    "https://images.unsplash.com/photo-1759701546662-b79f5d881124",
    "https://images.unsplash.com/photo-1759701547089-12599225b4c4",
    "https://images.pexels.com/photos/30324913/pexels-photo-30324913.jpeg",
  ],
};

export const NAV_LINKS = [
  { label: "Home", href: "#top" },
  { label: "Roster", href: "#roster" },
  { label: "Games", href: "#games" },
  { label: "Tournaments", href: "#tournaments" },
  { label: "Live", href: "#live" },
  { label: "News", href: "#news" },
  { label: "Contact", href: "#contact" },
];
